<script>
import { ref, onMounted, watch, onBeforeMount } from "vue";
export default {
	emits: ["changeState"],
	setup(props, { emit }) {
		const DOMready = ref(0);
		// const videoReady = ref(false);
		const videoState = ref("loading");
		// const frame = ref(null);
		// const initTime = 6;
		const rNum = parseInt(Math.random() * 15 + 80);

		let timer = null;
		let loadingEnd = false;
		// let t0 = null;
		// let t1 = null;
		// let t2 = null;
		// let t3 = null;

		// const delay = (s) => {
		// 	return new Promise((resolve, reject) => {
		// 		setTimeout(resolve, s);
		// 	});
		// };
		const timeCounter = () => {
			console.time("loading time");

			timer = setInterval(() => {
				DOMready.value += 0.5;
				// t0 = window.performance.now();

				if (DOMready.value > rNum) {
					// console.log(`loading percentage: ${rNum}%`);
					clearInterval(timer);
				}
			}, 5);
		};

		const handleEvent = (event) => {
			if (!loadingEnd) {
				if (event.type === "canplay") {
					videoState.value = event.type;
					loadingEnd = true;

					// delay()
					// 	.then(() => {
					// 		t1 = window.performance.now();
					// 		emit("changeState", true);
					// 		console.log(`loading time: ${t1 - t0} ms`);
					// 		return delay(500);
					// 	})
					// 	.then(() => {
					// 		t2 = window.performance.now();
					// 		frame.value.style.opacity = 0;
					// 		console.log(`fade out time: ${t2 - t1} ms`);
					// 		return delay(500);
					// 	})
					// 	.then(() => {
					// 		t2 = window.performance.now();
					// 		videoReady.value = true;
					// 		loadingEnd = true;
					// 		console.log(`hiding time: ${t2 - t1} ms`);
					// 	});
				}
				//console.log(event.type);
			}
		};

		onBeforeMount(() => {
			timeCounter();
		});

		onMounted(() => {
			const video = document.querySelector("#story_video_c1");

			video.addEventListener("loadstart", handleEvent);
			video.addEventListener("progress", handleEvent);
			video.addEventListener("canplay", handleEvent);
			video.addEventListener("canplaythrough", handleEvent);
		});

		watch(videoState, (nv, ov) => {
			if (nv === "canplay") {
				clearInterval(timer);
				// console.log("loading complete");

				const restNum = 100 - DOMready.value;
				const interval = setInterval(() => {
					DOMready.value += restNum / 160;
					// console.log("fake loading");
					if (DOMready.value > 100) {
						// frame.value.style.opacity = 0;
						// videoReady.value = true;
						// loadingEnd = true;
						emit("changeState", true);
						console.timeEnd("loading time");
						clearInterval(interval);
						timer = null;
					}
				}, 5);
			}
		});
		// watch(DOMready, (nv, ov) => {
		// 	console.log(nv);
		// });

		return {
			DOMready,
			// videoReady,
			// frame,
		};
	},
};
</script>

<template>
	<transition name="fade" v-show="DOMready < 100">
		<div
			class="loadingFrame"
			:style="{ position: DOMready < 100 ? 'fixed' : 'absolute' }"
		>
			<div class="text_en_light">{{
				parseInt(DOMready) > 100 ? 100 : parseInt(DOMready)
			}}</div>
		</div>
	</transition>
</template>

<style lang="sass" scoped>
.loadingFrame
	position: fixed
	width: 100%
	height: calc(100% + 15px)
	background-color: #000
	opacity: 1
	transition: opacity 2s
	z-index: 2000
	.text_en_light
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        height: 50px
        text-align: center
        font-size: 32px
        line-height: 50px

// .fade-enter-active, .fade-leave-active
//     transition: 0.8s
.fade-enter-from, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave-from
    opacity: 1
</style>
